let elipsRespon = gsap.matchMedia();

// ellips animation start
const ths = gsap.timeline({
    scrollTrigger: {
        trigger: '.hero-section',
        start: 'top top',
        end: '+=1080',
        scrub: true,
        pin: true,
        // markers: true,
    }
})

elipsRespon.add("(min-width: 2537px)", () => {
    ths.to('.hero-ellipse', {
        scale: 21,
    })
});

elipsRespon.add("(max-width: 2536px)", () => {
    ths.to('.hero-ellipse', {
        scale: 17,
    })
});

elipsRespon.add("(max-width: 1903px)", () => {
    ths.to('.hero-ellipse', {
        scale: 6,
    })
});


// ths.to('.hero-ellipse', {
//     scale: 6,
// }, 'thsAnimation')

// infinite slider start
const scrollers = document.querySelectorAll(".hero-slider-wrapp");
function addAnimation() {
    scrollers.forEach((scroller) => {
        scroller.setAttribute("data-animated", true);
        const scrollerInner = scroller.querySelector(".hero-slider-content");
        const scrollerContent = Array.from(scrollerInner.children);
        for (let i = 0; i < 5; i++) {
            scrollerContent.forEach((item) => {
                const duplicatedItem = item.cloneNode(true);
                duplicatedItem.setAttribute("aria-hidden", true);
                scrollerInner.appendChild(duplicatedItem);
            });
        }
    });
}

addAnimation();